export default __webpack_public_path__ + "static/media/TimedImage.90ad5ae9.png";